import { useLocation } from 'react-router-dom';

// import { ReactComponent as FoldedSheet } from '../../../assets/icons/FoldedSheet.svg';
import { ReactComponent as Briefcase } from '../../../assets/icons/Briefcase.svg';
import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { ReactComponent as Users } from '../../../assets/icons/Users.svg';
import { ReactComponent as Invoices } from '../../../assets/icons/Invoices.svg';
import { ReactComponent as ChargeIcon } from '../../../assets/icons/ChargeIcon.svg';
// import { ReactComponent as User } from '../../../assets/icons/User.svg';
import { ReactComponent as Reports } from '../../../assets/icons/Reports.svg';
import { ReactComponent as Clock } from '../../../assets/icons/Clock.svg';
import { ReactComponent as HelpIcon } from '../../../assets/icons/HelpIcon.svg';
import { paths } from '../../../routes';

const modules = [
  // { path: paths.home, label: 'Home', Icon: House },
  // { path: paths.documents, label: 'Documentos', Icon: FoldedSheet },
  {
    path: paths.pay,
    label: 'Pagos',
    Icon: Invoices,
    subModules: [
      { label: 'Proveedores', pathSubModule: paths.suppliers },
      // { label: 'Nómina', pathSubModule: paths.payrolls },
      { label: 'Servicios', pathSubModule: paths.agreements }
    ]
  },
  { path: paths.charge, label: 'Cobros', Icon: ChargeIcon },
  { path: paths.integrationCont, label: 'Reportes', Icon: Reports },
  { path: paths.paymentHistory, label: 'Historial', Icon: Clock }
  // // { path: paths.help, label: 'Servicio', Icon: HelpIcon }
  // { path: paths.integrationCont, label: 'Contabilidad', Icon: BaseDownArrow }
  // { path: paths.collaborators, label: 'Colaboradores', Icon: User },
  // { path: paths.payrolls, label: 'Nómina', Icon: Calendar }
];

const useSidebar = () => {
  const { pathname } = useLocation();

  const isConfigModules = [paths.config, paths.profiles].includes(pathname);

  return { modules, isConfigModules };
};

export default useSidebar;
